import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface DetailPageLayoutProps {
  children: React.ReactNode;
  title: string;
  backLink?: string;
  backLabel?: string;
  actions?: React.ReactNode;
}

/**
 * Modern layout for CRM detail pages (Contact, Company, Deal, Activity)
 * Matches the CustomerCrmHub design without the old CRM navigation
 */
const DetailPageLayout: React.FC<DetailPageLayoutProps> = ({
  children,
  title,
  backLink = '/crm',
  backLabel = 'Back to CRM',
  actions
}) => {
  return (
    <>
      {/* Header */}
      <div className="mb-6">
        <Link
          to={backLink}
          className="group mb-4 inline-flex items-center gap-2 text-sm text-gray-600 transition hover:text-gray-900"
        >
          <ArrowLeft className="h-4 w-4 transition group-hover:-translate-x-1" />
          {backLabel}
        </Link>
        
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          {actions && (
            <div className="flex items-center gap-3">
              {actions}
            </div>
          )}
        </div>
      </div>

      {/* Content */}
      <div className="space-y-6">
        {children}
      </div>
    </>
  );
};

export default DetailPageLayout;
